import { gql } from '@apollo/client';

  // TODO: have backend populate for question if its available
  // lastUpdatedUser
  // lastUpdatedTs

const questionSummary = `
	sectionId
	questionId
	orderNum
	leadInOption
	leadInQuestionId
	question
	answerType
	answerOptions
	answerCorrectValues
	status
`;

export const GET_ALL_SITE_VISIT_SECTIONS = gql`
  query {
    getAllSiteVisitSections {
      sectionId
      orderNum
      description
      status
      sectionConditionId
      createdUser
      createdTs
      lastUpdatedUser
      lastUpdatedTs
      siteVisitQuestions {
        ${questionSummary}
        followupQuestions {
          ${questionSummary}
          followupQuestions {
            ${questionSummary}
          }
        }
			}
		}
	}
`;



export const GET_QUESTION_BY_ID = gql`
  query GetQuestionById($questionId: Int!) {
    getQuestionById(questionId: $questionId) {
      sectionId
      questionId
      orderNum
      leadInOption
      leadInQuestionId
      question
      answerType
      contactType
      answerOptions
      answerCorrectValues
      status
      deficiency
      answerSql
      siteVisitType
      lastUpdatedUser
      lastUpdatedTs
      createdUser
      createdTs
	  }
	}
`;


